import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export default class ScaleInAnimation {
    static init() {
        Array.from(document.querySelectorAll('.scale-in-animation')).forEach(element => {
            new ScaleInAnimation(element);
        });
    }

    classes = {
        node: 'scale-in-animation'
    }

    constructor(element) {
        if (!element) return;
        this.element = element;
        this.isMobile = window.innerWidth < 768;
        this.innerElement = element.querySelector('.scale-in-animation__inner');
        this.scrollBtn = this.element.querySelector('.scale-in-animation__scroll-btn');

        gsap.registerPlugin(ScrollTrigger);

        let inner = gsap.timeline({
            scrollTrigger: {
                trigger: this.innerElement,
                toggleActions: "play none none reset",
                markers: false, // debug
                start: "top " + this.getHeaderHeight() + "px",
                end: "bottom " + this.getHeaderHeight() + "px",
                scrub: 1.5,
                paused: true,
                pin: this.innerElement,
            }
        })

        let contentElement = this.innerElement.querySelector('.scale-in-animation__content');
        let maskElement = this.innerElement.querySelector('.scale-in-animation__mask');
        let maskShapeElement = this.innerElement.querySelector('.scale-in-animation__mask__shape');
        let bgElement = this.innerElement.querySelector('.scale-in-animation__bg');
        let bgImageElement = bgElement.querySelector('.hero-image__background');
        let bgSublineElement = bgElement.querySelector('.subline');
        let bgContentElement = bgElement.querySelector('.hero__content');
        let bgTitleElement = bgElement.querySelector('.hero__title');
        let bgButtonElement = bgElement.querySelector('.btn');

        let duration = 2.5;
        let position = 2;

        inner
            .set(contentElement, {
                pointerEvents: "auto",
                opacity: 1,
                y: 125
            })
            .to(contentElement, {
                opacity: 0,
                duration: .3,
                y: 200
            }, position * .075)
            .to(contentElement, {
                pointerEvents: "none",
            }, position * .225)
            .to(maskShapeElement, {
                webkitMaskSize: "2700vw",
                maskSize: "2700vw",
                webkitMaskPositionX: "calc(50% - 46vw)",
                ease: "sine.out",
                duration: duration,
            }, position * .1)
            .to(maskElement, {
                opacity: 0,
                duration: 0.2,
                stagger: 0
            }, position * .5)
            .to(maskElement, {
                pointerEvents: "none",
                duration: .3,
            }, position * .65)
            .to(bgElement, {
                pointerEvents: "auto",
                duration: .3
            },position * .25)
            .to(bgImageElement, {
                opacity: 1,
                duration: .3,
            },position * .5)
            .to(bgTitleElement, {
                opacity: 1,
                duration: .3,
                x: 0
            },position * .55)
            .to([bgSublineElement, bgContentElement], {
                opacity: 1,
                duration: .3,
                x: 0
            },position * .6)
            .to(bgButtonElement, {
                opacity: 1,
                duration: .3,
                x: 0
            }, position * .65);

        this.scrollBtn.addEventListener('click', async () => {
            if (this.isMobile) {
                window.scrollTo({top: this.element.offsetTop + this.element.getBoundingClientRect().height - window.innerHeight, behavior: 'smooth'});
            } else {
                let scrollEnd = this.element.getBoundingClientRect().bottom - window.innerHeight;
                this.scrollByY(scrollEnd, 0);
            }
        });
    }

    scrollByY(y, time) {
        const start = performance.now();
        const startY = window.scrollY;
        const endY = startY + y;
        while (performance.now() < start + time) {
            const progress = (performance.now() - start) / time;
            window.scrollTo(0, startY + y * progress);
        }
        window.scrollTo(0, endY);
    }

    getHeaderHeight() {
        return parseInt((getComputedStyle(document.documentElement).getPropertyValue('--header-height')).trim());
    }
}
